module.exports = __webpack_public_path__ + "static/media/bananas-food-fruit-svgrepo-com.6ac6be30.svg";